import { LicensesType } from './IUserData'

export enum LamenessColumnKey {
	TREATMENT_PLAN = 'treatment_plan',
	LACTATION_DAY = 'lactation_day',
	DIAGNOSIS = 'diagnosis',
	TREATMENT_STATUS = 'treatment_status',
	INSPECTION_DATE = 'inspection_date',
	COW_AGE = 'cow_age',
	GROUP = 'group',
	LACTATION_STATUS = 'lactation_status',
	FATNESS = 'fatness',
	EXAMINER = 'examiner',
}

export enum LameHeadsColumnKey {
	GROUP = 'group',
	LIMPNESS = 'limpness',
	LIMPNESS_LENGTH = 'limpness_length',
	LIMPNESS_CHANGE_DT = 'limpness_change_dt',
	COW_AGE = 'cow_age',
	LACTATION_DAY = 'lactation_day',
	FATNESS = 'fatness',
}

export type ColumnTypes = {
	key: LamenessColumnKey | LameHeadsColumnKey | string
	title: string
	isShowColumn: boolean
	requiresLicense?: LicensesType
	requiresMilkYield?: boolean
}

export enum LamenessStatus {
	One = '1',
	Two = '2',
	Three = '3',
	Four = '4',
	Five = '5',
}

export enum TreatmentStatus {
	NotPrescribed = 'not_prescribed',
	Suspended = 'suspended',
	Treated = 'treated',
	Completed = 'completed',
	NotRequired = 'not_required',
	DisposeRecommended = 'dispose_recommended',
}

export enum InspectionStatus {
	Required = 'required',
	Planned = 'planned',
	Expired = 'expired',
	Completed = 'completed',
	NotPlanned = 'not_planned',
}

export enum LactationStatus {
	Lactating = 'lactating',
	NonLactating = 'non_lactating',
	DefectiveMilk = 'defective_milk',
	CommercialMilk = 'commercial_milk',
}

export enum LamenessTypeChart {
	LamenessType = 'lameness',
	PointType = 'point',
}

export interface IFiltersLamenessTable {
	tags: number[]
	lameness: {
		statuses: LamenessStatus[]
		startOf: number | string
		endOf: number | string
	}
	treatmentStatus: {
		statuses: TreatmentStatus[]
		startOf: number | string
		endOf: number | string
	}
	inspectionStatus: {
		statuses: InspectionStatus[]
		startOf: number | undefined
		endOf: number | undefined
	}
	diagnoses: {
		ids: number[]
	}
	cowAge: {
		startOf: number | string
		endOf: number | string
	}
	groups: {
		ids: number[]
	}
	lactation: {
		statuses: LactationStatus[]
		startOf: number | string
		endOf: number | string
	}
	fatness: IFatness
	examiners: {
		ids: number[]
	}
	lastTrim: {
		startOf: number | string
		endOf: number | string
	}
	lastMilking: {
		startOf: number | string
		endOf: number | string
	}
	lastLamenessMeasurement: {
		startOf: number | string
		endOf: number | string
	}
	responsiblePersons: {
		ids: number[]
	}
	isLateTrims: boolean
	dateRange?: {
		startDate: number
		endDate: number
	}
	tag_id_search?: string
}

export interface ILameness {
	key: LamenessStatus
	title: string
	id: number
}

export interface ITreatment {
	key: TreatmentStatus
	title: string
	id: number
}

export interface IInspection {
	key: InspectionStatus
	title: string
	id: number
}

export interface ILactation {
	key: LactationStatus
	title: string
	id: number
}
export interface IFatness {
	startOf: number | ''
	endOf: number | ''
	statuses?: Array<'ok' | 'attention' | 'obese' | 'emaciated'>
}

export enum PositionHoof {
	Front_Left = 'front_left',
	Front_Right = 'front_right',
	Rear_Left = 'rear_left',
	Rear_Right = 'rear_right',
	All = 'all',
}

export interface ICheckupList {
	diagnosis: IDiagnosisBlock[]
	next_examination_date: number | null
	milk_reject_start: number | null
	milk_reject_end: number | null
	dispose_recommended: boolean
	comment: string
	id?: number
	created_dt?: number
	examiner?: IExaminersHistoryResponse
	limpness?: number
	trim: IExaminersTrim
}

export interface IExaminersTrim {
	isTrim: boolean
	target_date: number | undefined
	responsible_id: number | undefined
	done_dt?: number
	comment: string
}

interface IExaminersHistoryResponse {
	id: number
	firstname: string
	lastname: string
	position: string
}

export interface IDiagnosisBlock {
	position: PositionHoof
	sickness?: IDiagnosesResponse[]
	sickness_id?: number[]
	comment: string
	treatment_plans_id?: number[]
	treatment_plans?: {
		id: number
		title?: string
		description?: string
	}[]
}

export interface IExaminersResponse {
	id: number
	name: string
	position: string
}
export interface IDiagnosesRes {
	items: IDiagnosesResponse[]
}
export interface IDiagnosesResponse {
	id: number
	title: string
	group: string
}
